import React, { useRef, useState, useEffect } from "react";

const ReportActionCard = ({
  cardPosition,
  handleCloseCard,
  activeAccordionStudents,
  toAllStudentResults,
  toReportCards,
  setViewParent,
  setViewTeacher,
  assessmentName,
}) => {
  const printCardRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  console.log(selectedStudentIds, "selectedStudentIds in ReportActionCard");

  useEffect(() => {
    setSearchQuery("");
    setSelectedStudentIds([]);
    setSelectAll(false);
  }, [activeAccordionStudents]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleStudentSelect = (studentId) => {
    setSelectedStudentIds((prevSelected) =>
      prevSelected.includes(studentId)
        ? prevSelected.filter((id) => id !== studentId)
        : [...prevSelected, studentId]
    );
    setSearchQuery("");
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStudentIds([]);
    } else {
      setSelectedStudentIds(
        activeAccordionStudents.map((student) => student.id)
      );
    }
    setSelectAll(!selectAll);
  };

  const filteredStudents = activeAccordionStudents.filter((student) =>
    student.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      ref={printCardRef}
      className="action-card"
      style={{
        position: "absolute",
        top: `${cardPosition.top}px`,
        left: `${cardPosition.left}px`,
        zIndex: 1000,
        width: "320px",
        padding: "16px", // Ensure consistent padding
      }}
    >
      <div className="action-card-header" style={{ marginBottom: "16px" }}>
        <p className="action-header">
          {assessmentName?.split(" ")[1]} Report Cards
        </p>
        <button onClick={handleCloseCard} className="close-button">
          ✕
        </button>
      </div>

      <div className="action-card-body">
        <div className="action-search-bar" style={{ marginBottom: "16px" }}>
          <img
            src={process.env.PUBLIC_URL + "/assets/imgs/search-outline.svg"}
            alt="Search"
            className="search-icon"
          />
          <input
            type="text"
            placeholder="Search student"
            value={searchQuery}
            onChange={handleSearchChange}
            style={{
              border: "none",
              outline: "none",
              width: "100%",
              background: "transparent",
            }}
          />
        </div>

        {searchQuery && (
          <div className="search-results">
            {filteredStudents.map((student) => (
              <div
                key={student.id}
                className="search-result-item"
                onClick={() => handleStudentSelect(student.id)}
                style={{
                  backgroundColor: selectedStudentIds.includes(student.id)
                    ? "#e0e0e0"
                    : "transparent",
                }}
              >
                {student.name}
              </div>
            ))}
          </div>
        )}
        <div className="select-all-container">
          <input
            type="checkbox"
            id="selectAll"
            name="selectAll"
            checked={selectAll}
            onChange={handleSelectAll}
          />
          <label htmlFor="selectAll">View All Students</label>
        </div>
        {selectedStudentIds.length > 0 && (
          <div className="selected-students">
            {selectedStudentIds.map((studentId) => {
              const student = activeAccordionStudents.find(
                (student) => student.id === studentId
              );
              return (
                <div key={studentId} className="selected-student-item">
                  <input
                    type="checkbox"
                    checked={selectedStudentIds.includes(studentId)}
                    onChange={() => handleStudentSelect(studentId)}
                  />
                  <label>{student.name}</label>
                </div>
              );
            })}
          </div>
        )}
        <div className="action-button-container">
          <button
            className={`blue-action-button ${
              selectedStudentIds.length === 0 ? "disabled-button" : ""
            }`}
            disabled={selectedStudentIds.length === 0}
            onClick={() => {
              setViewParent(true);
              setViewTeacher(false);
              toAllStudentResults(selectedStudentIds, true, false);
            }}
          >
            Simple
          </button>
          <button
            className={`blue-action-button ${
              selectedStudentIds.length === 0 ? "disabled-button" : ""
            }`}
            disabled={selectedStudentIds.length === 0}
            onClick={() => {
              setViewParent(false);
              setViewTeacher(true);
              toAllStudentResults(selectedStudentIds, false, true);
            }}
          >
            Detailed
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportActionCard;
